import React from "react";

export default function IconCheckmarkAlt(props) {
  return (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 6.71429L5.2 11L15 1" stroke="#A82D9C" strokeWidth="2" />
    </svg>
  );
}
